//@import dependencies
import React from 'react'
//@end

// @import config
// @end

//@import components
import {HeaderPublicCommonLayout} from 'app_components/commons/header'
import FooterPublicCommon from 'app_components/commons/footer/footerPublic'
import PublicHeader from './components/PublicHeader/PublicHeader'
// import { FaviconCommonLayout } from 'app_components/commons/helmet/favicon'
//@end

// @ADD Component types
interface IPublicAppComponent {
  children?: any
}

const PublicAppComponent: React.FC<IPublicAppComponent> = (props) => {
  return(
    <div className={`public-app-layout`}>
      <div className='wrapper'>
        <div className='main'>
          <PublicHeader/>
          {/* <HeaderPublicCommonLayout /> */}
          <main>
            {props.children}
          </main>
          <footer>
            <FooterPublicCommon />
          </footer>
        </div>
      </div>
    </div>
  )
}

export default PublicAppComponent
